import { PaginatedListPayload, StoreListData } from "interfaces";
import { GenericAxiosResponse } from "interfaces/api";
import { flow, getRoot, types } from "mobx-state-tree";
import {
  getVehicleParts,
  createVehiclePart,
  updateVehiclePart,
} from "services/api/vehicleParts";
import cloneDeep from "utils/cloneDeep";
import NProgress from "nprogress";
import { defaultStoreList } from "utils/constants";
import { RootStore } from "..";

/**
 * This file is generated as an example of Mobx State Tree Stores
 *
 * To learn more about Mobx and Mobx State Tree,
 * please visit https://mobx-state-tree.js.org/intro/welcome
 */

export const VehiclePartsStore = types
  .model("VehicleParts", {
    data: types.optional(
      types.frozen<StoreListData>(),
      cloneDeep(defaultStoreList)
    ),
    query: types.optional(types.frozen<PaginatedListPayload>(), {}),
  })
  .views((self) => ({
    get rootStore() {
      return getRoot<typeof RootStore>(self);
    },
  }))
  .actions((self) => ({
    setQuery(payload: PaginatedListPayload) {
      const currentData = cloneDeep(self.query);
      self.query = { ...currentData, ...payload };
    },
    resetQuery() {
      self.query = {};
    },
    getVehicleParts: flow(function* (payload) {
      NProgress.start();
      try {
        const resp: GenericAxiosResponse = yield getVehicleParts({
          ...self.query,
          ...payload,
        });
        const { data, ...rest } = resp.data.data;
        self.data = {
          listItems: data,
          meta: rest,
        };
        return resp.data.data;
      } catch (error) {
        //set global error
        console.log({ ...error });
        console.log(`error`, error);
      } finally {
        NProgress.done();
      }
    }),
  }))
  .actions((self) => ({
    createPart: flow(function* (payload) {
      try {
        console.log("CREATIUNG IN<MOBX");
        const resp: GenericAxiosResponse = yield createVehiclePart(payload);
        self.getVehicleParts({});
        self.rootStore.toastStore.addSuccessToast(
          "Vehicle Part successfully created"
        );
        return resp.data.data;
      } catch (error) {
        //set global error
        console.log(`error`, error);
        self.rootStore.toastStore.addErrToast(error);
        throw error;
      }
    }),
    updatePart: flow(function* (partId, payload) {
      try {
        const resp: GenericAxiosResponse = yield updateVehiclePart(
          partId,
          payload
        );
        self.getVehicleParts({});
        self.rootStore.toastStore.addSuccessToast(
          "Vehicle Part successfully updated"
        );
        return resp.data.data;
      } catch (error) {
        //set global error
        console.log(`error`, error);
        self.rootStore.toastStore.addErrToast(error);
        throw error;
      }
    }),
  }));
